export default {
  infoToolTipText: '<p><strong>Format de réponse</strong><br><ul><li>4 à 25 caractéres</li><li>composée de chiffres et/ou de lettres</li><li>ne contient aucun accent</li><li>ne contient aucun caractére spécial</li></ul></p>',
  questions: {
    label: 'Question',
  },
  answers: {
    label: 'Réponse',
    lengthError: 'La réponse doit contenir un minimum de 4 et un maximum de 25 caractères.',
    formatError: 'La réponse doit être sans accents ni caractères spéciaux.',
    lengthAndFormatError: 'La réponse doit contenir de 4 à 25 caractères, sans accents ni caractères spéciaux.',
    unicityError: 'Chaque réponse ne peut être utilisée qu\'une seule fois.',
  },
};
